import React from 'react';
import { isRichTextHtml } from '../../utils/richText';

interface RichTextDisplayProps {
  content: string;
  className?: string;
  style?: React.CSSProperties;
}

export const RichTextDisplay: React.FC<RichTextDisplayProps> = ({
  content,
  className = '',
  style,
}) => {
  if (!content) {
    return null;
  }

  if (isRichTextHtml(content)) {
    return (
      <div
        className={`tiptap ${className}`.trim()}
        style={style}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  return (
    <div className={className} style={{ whiteSpace: 'pre-wrap', ...style }}>
      {content}
    </div>
  );
};
